<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    modelValue?: string | null
    items: { label: string; value: string }[]
    class?: string
  }>(),
  {
    modelValue: null,
    class: undefined,
  },
)

const id = `radio-${Math.random().toString(36).slice(2, 9)}`

const classes = computed(() => ({
  'app-radio-group': true,
  [`${props.class}`]: !!props.class,
}))

defineEmits<{
  (event: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <div :class="classes">
    <div v-for="item in items" :key="item.value" class="app-radio-group__item">
      <input
        :id="`${id}-${item.value}`"
        type="radio"
        :name="id"
        :value="item.value"
        :checked="modelValue === item.value"
        @change="
          $emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
      />

      <label :for="`${id}-${item.value}`">
        <span class="app-radio-group__item__radio"></span>
        <span class="app-radio-group__item__label" v-html="item.label"></span>
      </label>
    </div>
  </div>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-radio-group {
}

.app-radio-group__item {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  padding-left: 2rem;
  user-select: none;

  &:last-child {
    margin-bottom: 0;
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }

  label {
    flex: 1 1 0%;
    font-family: $font-barlow;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.6666666667;
    letter-spacing: 0.0833333333em;
    text-transform: uppercase;
    color: $black;
    cursor: pointer;

    &:hover {
      .app-radio-group__item__radio {
        &::before {
          opacity: 0.1;
        }
      }
    }
  }

  input:checked + label .app-radio-group__item__radio {
    &::before {
      opacity: 1;
    }
  }
}

.app-radio-group__item__radio {
  position: absolute;
  top: 0;
  left: 0;
  width: 1.25rem;
  height: 1.25rem;
  background-color: $gray-100;
  border: 1px solid $gray-200;
  border-radius: 50%;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    @include transition('opacity', 0.1s);
  }
}

.app-radio-group__item__label {
  a {
    text-decoration: underline;
  }
}
</style>
